import React from 'react'
import Find from '../../ui/views/share/components/Find/Find'
import TourMain from '../../ui/views/tours/TourMain/TourMain'
import ToursHeader from '../../ui/views/tours/ToursHeader/ToursHeader'
import CarouselSevices, { servicesTravel } from '../../ui/views/share/components/CarouselServices/CarouselSevices'

import './Assets/styles.css'
import ContactWellezy from '../../Components/ContactWellezy/ContactWellezy'
import TourAllCard from '../../ui/views/tours/TourAllCard/TourAllCard'
import TourResultSearch from '../../ui/views/tours/TourResultSearch/TourResultSearch'


import useTours from '../../ui/viewModels/tours/Tours'
import { set } from 'date-fns'
import TourPaginado from '../../ui/views/tours/TourPaginado/TourPaginado'
import AnyQuestions from '../../ui/views/home/components/anyQuestion'

function Tours() {

  const { loading, findTours, data, error, place, setPlace, dataAlways, nextPag,
    infoData, prevPag } = useTours()


  return (
    <div>
      <Find />
      <CarouselSevices current={servicesTravel[2].title} />
      <ToursHeader
        findTours={findTours}
        place={place}
        setPlace={setPlace}
        error={error}
      />

      <TourResultSearch
        loading={loading}
        data={data}
      />
      <div className='tours_main'>

        {
          data == false &&
          <TourAllCard data={dataAlways} loading={loading} />
        }

        <TourPaginado
          data={infoData}
          identificador={data == false ? 'DA' : 'DO'}
          prev={prevPag}
          next={nextPag}
        />

        <TourMain />

        <AnyQuestions title={"¿Tienes alguna duda?"} />
      </div>

    </div>
  )
}

export default Tours